const reserveCheck = () => import('@/views/main/reserve/check/check.vue')
export default {
  path: '/main/reserve/check',
  name: 'reserveCheck',
  component: reserveCheck,
  children: []
}
